import { Component, ElementRef, viewChild, inject, DestroyRef } from '@angular/core';
import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { GridApi, ICellEditorParams } from '@ag-grid-community/core';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomEditorParams } from './custom-cell-editor.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'rx-input-cell-editor',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  styleUrl: './custom-cell-editor.component.scss',
  templateUrl: './custom-cell-editor.component.html',
})
export class CustomInputCellEditorComponent implements ICellEditorAngularComp {
  private params!: ICellEditorParams;
  public value!: string;
  public isDuplicate: boolean = false;
  public inputControl: FormControl;
  private destroyRef = inject(DestroyRef);

  input = viewChild<ElementRef>('input');
  duplicateMessage: string = 'This item already exists';

  allRowsValues: string[] = [];

  constructor() {
    this.inputControl = new FormControl('');
  }

  agInit(params: CustomEditorParams): void {
    this.params = params;
    this.value = this.params.value;
    this.duplicateMessage = this.params['duplicateMessage'];
    this.inputControl.setValue(this.value);
    this.allRowsValues = this.getAllValues(this.params.api);

    this.inputControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.value = value;
      this.checkForDuplicates();
    });
  }

  checkForDuplicates(): void {
    const trimmedValue = this.value.trim();
    this.isDuplicate = trimmedValue.length > 0 && this.allRowsValues.map(v => v.trim()).includes(trimmedValue);
  }

  getAllValues(gridApi: GridApi): string[] {
    const rowData = [];
    gridApi.forEachNode((node) => rowData.push(node.data.value));
    return rowData;
  }

  getValue(): string | number {
    return this.value;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.params.stopEditing();
    }
  }

  afterGuiAttached(): void {
    this.input().nativeElement.focus();
  }

  isCancelAfterEnd(): boolean {
    return !this.getValue() || this.isDuplicate;
  }
}
